export default "__VITE_ASSET__CPDMxocB__"